import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface IStepOneImageBoxProps {
    imageContainerClass?: string;
    imageUrl: string;
    textContainerClass: string;
    chipIcon: JSX.Element;
    chipLabel: string;
    outerLabel: string;
}

const StepOneImageBox = ({
    imageContainerClass,
    imageUrl,
    textContainerClass,
    chipIcon,
    chipLabel,
    outerLabel,
}: IStepOneImageBoxProps) => (
    <Box
        className={`buying-online-steps--square-img-container ${imageContainerClass}`}
        sx={{
            backgroundImage: `url("${imageUrl}")`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            borderRadius: 2,
            height: { xs: '20rem', md: '22.5rem' },
            width: { xs: '100%' },
        }}
    >
        <Stack
            direction="row"
            useFlexGap
            sx={{
                py: 3,
                height: '100%',
                alignItems: 'flex-end',
                justifyContent: 'center',
            }}
        >
            <Box className={`buying-online-steps--step-img-text-container ${textContainerClass}`}>
                <Stack
                    direction={{ xs: 'row', sm: 'column', md: 'row' }}
                    spacing={1}
                    useFlexGap
                    sx={{ alignItems: 'center' }}
                >
                    <Typography component="h3" variant="body1" color="#fff">
                        {outerLabel}
                    </Typography>
                    <Chip
                        icon={chipIcon}
                        label={chipLabel}
                        color="primary"
                        variant="weak"
                        sx={{ fontSize: '.875rem' }} // TODO ask Stefanie about larger font override in design
                    />
                </Stack>
            </Box>
        </Stack>
    </Box>
);

export default StepOneImageBox;
